import React, { useState, useRef } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import download from 'downloadjs';
import request from '../../request'
import Notify from './Notify'
import historyService from '../../services/historyService';
import getItemMenu from './getItemMenu';
import Usr from '../../services/user';
import { lastProps } from './nameExcel';
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons'
import queueExcel from '../../services/queueExcel';

export default function DescargarExcel (props) {
    const [loading, setLoading] = useState(false)
    const cabecera = useRef(null)

    const emp = {
        GEO: 'GEOMACO',
        ELS: 'EL SOL',
        SUP: 'SUPERMAT',
        ELA: 'SUPERMAT',
        HIP: 'HIPERCAT',
        SIST: 'SISTEMAS',
        DIR: 'DASHBOARD DIRECCION'
    }

    const getFch =  () => {
        const fch = lastProps.fch

        if (!fch) return moment().format('DD/MM/YYYY')

        return typeof fch === 'string' ? moment(fch).format('DD/MM/YYYY') : `${moment(fch.dsd).format('DD/MM/YYYY')} - ${moment(fch.hst).format('DD/MM/YYYY')}`
    }

    const card = (itemExcel) => `<div class="d-flex flex-column text-center justify-content-center align-items-center alerta-excel" style="width: 500px">
                                    <div class="fw-medium">${getItemMenu() ? getItemMenu().IMenuNom : 'REPORTE'}</div>
                                    <div class="fw-medium">Hoja <span id="${itemExcel.token}-hoja">${itemExcel.hoja}</span>/${itemExcel.hojas}</div>
                                    <div class="fw-medium">Filas <span id="${itemExcel.token}-filas">${itemExcel.fila}/${itemExcel.filas}</span></div>
                                    <div class="d-flex full-width justify-content-center my-1">
                                        <div class="spinner-grow spinner-grow-sm mx-1"></div>
                                        <div class="spinner-grow spinner-grow-sm mx-1"></div>
                                        <div class="spinner-grow spinner-grow-sm mx-1"></div>
                                        <div class="spinner-grow spinner-grow-sm mx-1"></div>
                                    </div>
                                    <span class="fw-medium" id="${itemExcel.token}-label">
                                        ${itemExcel.hoja === itemExcel.hojas && itemExcel.fila === itemExcel.filas
                                            ? 'Procesando...'
                                            : 'Escribiendo...'
                                        }
                                    </span>
                                    <div class="hidden-not-hover">
                                        Por favor espere, estamos generando su informe.
                                        <br/>
                                        Puede seguir navegando por el sitio mientras espera.
                                        <br/>
                                        Si el informe contiene muchas filas puede que demore unos minutos.
                                        <br/>
                                    </div>
                                </div>`

    const esperar = (itemExcel, tokenExcel, nombre, url, paramsCong, notify, hidden) => {
        const consultar = () => request.Post(url, { tokenExcel, paramsCong }, r => {
            download(r, nombre + ".xlsx");
            hidden()
            Notify({ type: 'archivo_success', classes: 'bg-positive' })

            setLoading(false)

            if (props.success) props.success()
        }, 'blob',
        e => {
            if (e.pending) {
                console.log(document.getElementById(tokenExcel + '-hoja'), document.getElementById(tokenExcel + '-filas'), document.getElementById(tokenExcel + '-label'))
                document.getElementById(tokenExcel + '-hoja') && (document.getElementById(tokenExcel + '-hoja').innerHTML = e.hoja)
                document.getElementById(tokenExcel + '-filas') && (document.getElementById(tokenExcel + '-filas').innerHTML = `${e.fila}/${e.filas}`)
                document.getElementById(tokenExcel + '-label') && (document.getElementById(tokenExcel + '-label').innerHTML = e.hoja === e.hojas && e.fila === e.filas
                    ? 'Procesando...'
                    : 'Escribiendo...'
                )

                esperar(e, tokenExcel, nombre, url, paramsCong, notify, hidden)
            } else {
                setLoading(false)

                if (props.success) props.success()
            }
        })

        setTimeout(consultar, 5000) // espera 2 segundos
    }

    const getExcel = e => {
        e.preventDefault()

        setLoading(true)

        const url = props.ipserv + props.route + 'excel/'
        const tokenExcel = props.tokenExcel
        const nombre = props.nombreExcel || 'Reporte'
        const success = () => setLoading(false)
        const error = () => {
            setLoading(false)
            if (props.error) props.error()
        }

        // Fix: Detect Super Admin or Normal User
        const adminProfile = (() => {
            try { return JSON.parse(localStorage.getItem('tufila_admin')) || null; }
            catch { return null; }
        })();

        const menu = getItemMenu()
        const menuNom = menu ? (menu.IMenuNom + " - " + menu.IMenuEmp) : (props.titulo || 'Reporte de Plataforma')
        
        const user = Usr
        const usuario = adminProfile 
            ? adminProfile.AdminNombre 
            : `${user.Apellido()}, ${user.Nombre()}`
            
        const fch = getFch()
        
        // Resolve Enterprise/Unit
        const k = menu ? menu.IMenuEmp : (adminProfile ? 'PLATAFORMA' : '')
        const empresa = emp[k] || k
        
        const paramsCong = {
            Link: historyService.getPathname(),
            MenuId: menu ? menu.IMenuId : 0,
            MenuNom: menuNom,
            UniNeg: k,
            Usuario: adminProfile ? adminProfile.AdminNombre : `${user.Id()} - ${user.Apellido()}, ${user.Nombre()}`,
            UsrId: adminProfile ? adminProfile.AdminId : user.Id()
        }

        const paramsExcel = {
            titulo: menuNom,
            usuario,
            fch,
            empresa,
            crudo: !cabecera.current.checked
        }

        queueExcel.addItem({ url, tokenExcel, paramsExcel, columnas: props.columnas || [], paramsCong, nombre, success, error, menuNom })
    }

    return <div className='d-flex align-items-center gap-3 sa-excel-control'>
        <Button
            disabled={loading || props.disabled}
            className={`sa-btn sa-btn-success d-flex align-items-center gap-2 ${loading ? 'loading' : ''}`}
            style={{ ...props.style, minWidth: '160px', height: '42px', borderRadius: '10px' }}
            onClick={getExcel}
        >
            {loading
                ? <Spinner animation="border" size="sm" />
                : <><FontAwesomeIcon icon={faFileExcel} style={{ fontSize: '1rem' }} /> {props.botonText || 'Descargar Excel'}</>
            }
        </Button>

        {!loading && (
            <div className='sa-checkbox-group d-flex align-items-center' style={{ background: 'rgba(255,255,255,0.03)', padding: '6px 14px', borderRadius: '10px', border: '1px solid rgba(255,255,255,0.08)' }}>
                <input
                    id="filtros-check"
                    defaultChecked={true}
                    ref={cabecera}
                    type="checkbox"
                    className="sa-custom-checkbox mr-2"
                    style={{ cursor: 'pointer', accentColor: '#10b981', width: '18px', height: '18px' }}
                />
                <label 
                    className="mb-0" 
                    htmlFor="filtros-check" 
                    style={{ cursor: 'pointer', fontSize: '0.85rem', fontWeight: 600, color: '#94a3b8', userSelect: 'none' }}
                >
                    Incluir Cabecera
                </label>
            </div>
        )}
    </div>
}